import { render, staticRenderFns } from "./ExpandableInputPreview.vue?vue&type=template&id=1089bad1&scoped=true&"
import script from "./ExpandableInputPreview.vue?vue&type=script&lang=ts&"
export * from "./ExpandableInputPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandableInputPreview.vue?vue&type=style&index=0&id=1089bad1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1089bad1",
  null
  
)

export default component.exports